<template>
    <div class="card is-loading">
        <div class="image"></div>
        <div class="details-container">
            <div class="category-date">
                <div class="category"></div>
                <div class="date"></div>
            </div>
            <h2></h2>
            <p class="excerpt"></p>
            <div class="tags">
                <p></p>
                <p></p>
                <p></p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.card.is-loading {
    margin: 3rem 0;

    .image,
    .category,
    .date,
    h2,
    p {
        background: #eee;
        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
        background-size: 200% 100%;
        animation: 1.5s shine linear infinite;
    }

    .image {
        height: 300px;
        width: 100%;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .details-container {
        display: flex;
        flex-direction: column;
        margin-top: 1.5rem;
        gap: 1rem;

        .category-date {
            display: flex;
            height: 30px;

            .category {
                width: 100px;
            }

            .date {
                width: 150px;
            }
        }

        h2 {
            height: 50px;
        }

        p {
            height: 30px;

            &.excerpt {
                height: 100px;
                margin-bottom: 0;
            }
        }

        .tags {
            display: flex;
            gap: 1rem;

            p {
                width: 100px;
            }
        }
    }
}

@keyframes shine {
    to {
        background-position-x: -200%;
    }
}
</style>